import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fillRule="evenodd"
    clipRule="evenodd"
    {...props}
  >
    <path
      d="M1 4C1 2.34315 2.34315 1 4 1H20C21.6569 1 23 2.34315 23 4V20C23 21.6569 21.6569 23 20 23H4C2.34315 23 1 21.6569 1 20V4Z"
      fill="#9747FF"
    />
    <path
      d="M4 22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2H4C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22ZM4 1C2.34315 1 1 2.34315 1 4V20C1 21.6569 2.34315 23 4 23H20C21.6569 23 23 21.6569 23 20V4C23 2.34315 21.6569 1 20 1H4Z"
      fill="#9747FF"
    />
    <path
      d="M5.5 6.66667C5.5 6.39053 5.72386 6.16667 6 6.16667H18C18.2761 6.16667 18.5 6.39053 18.5 6.66667C18.5 6.94281 18.2761 7.16667 18 7.16667H17.8333V14.6667C17.8333 15.311 17.311 15.8333 16.6667 15.8333H13.2071L15.0202 17.6465C15.2155 17.8417 15.2155 18.1583 15.0202 18.3536C14.825 18.5488 14.5084 18.5488 14.3131 18.3536L12 16.0404L9.68689 18.3536C9.49162 18.5488 9.17504 18.5488 8.97978 18.3536C8.78452 18.1583 8.78452 17.8417 8.97978 17.6465L10.7929 15.8333H7.33333C6.689 15.8333 6.16667 15.311 6.16667 14.6667V7.16667H6C5.72386 7.16667 5.5 6.94281 5.5 6.66667ZM7.16667 7.16667V14.6667C7.16667 14.7587 7.24129 14.8333 7.33333 14.8333H16.6667C16.7587 14.8333 16.8333 14.7587 16.8333 14.6667V7.16667H7.16667ZM14.6667 8.83334C14.9428 8.83334 15.1667 9.0572 15.1667 9.33334V12.6667C15.1667 12.9428 14.9428 13.1667 14.6667 13.1667C14.3905 13.1667 14.1667 12.9428 14.1667 12.6667V9.33334C14.1667 9.0572 14.3905 8.83334 14.6667 8.83334ZM12 10.1667C12.2761 10.1667 12.5 10.3905 12.5 10.6667V12.6667C12.5 12.9428 12.2761 13.1667 12 13.1667C11.7239 13.1667 11.5 12.9428 11.5 12.6667V10.6667C11.5 10.3905 11.7239 10.1667 12 10.1667ZM9.33333 11.5C9.60948 11.5 9.83333 11.7239 9.83333 12V12.6667C9.83333 12.9428 9.60948 13.1667 9.33333 13.1667C9.05719 13.1667 8.83333 12.9428 8.83333 12.6667V12C8.83333 11.7239 9.05719 11.5 9.33333 11.5Z"
      fill="white"
    />
  </svg>
);
